<!-- <ngx-spinner type="ball-spin" color="#ffffff"> -->
<ngx-spinner type="ball-spin" color="var(--theme-primary-color)">
  <p style="color: white">{{ AppConfig.LOADING_TEXT }}</p>
</ngx-spinner>
